@if (ref(); as r) {
  <!-- File ref: single card with header + embedded file content -->
  <mat-card appearance="outlined" class="ai-card">
    <app-card-header [displayName]="data().label">
      <app-type-chip [type]="chipType()" />
    </app-card-header>

    <app-file-block-card [ref]="r" [kind]="kind()" [metadata]="data().metadata" [embedded]="true" [block]="data()" />

    @if (layerContract()) {
    <div class="px-3 pb-2 d-flex flex-wrap gap-1">
      <app-type-chip type="count" [label]="layerTypeLabel()" />
      @if (layerEntity(); as entity) {
      <app-type-chip type="count" [label]="entity" class="ms-1" />
      }
    </div>
    }

    <app-block-debug-meta [kind]="kind()" [data]="data()" />
  </mat-card>
} @else if (hasResult() && isKnownKind()) {
  <!-- Inline or SSE stream result: single card with result -->
  <mat-card appearance="outlined" class="ai-card">
    <app-card-header [displayName]="data().label">
      <app-type-chip [type]="chipType()" />
    </app-card-header>

    <mat-card-content class="px-3 pt-2 pb-2">
      <span class="mat-font-label-sm text-body-secondary d-block mb-1">Result</span>
      <app-content-data-viewer [data]="dataResult()" />
    </mat-card-content>

    @if (geojsonFeatureCount() !== null || layerContract()) {
    <div class="px-3 pb-2 d-flex flex-wrap gap-1">
      @if (geojsonFeatureCount() !== null) {
      <mat-chip>{{ geojsonFeatureCount() }} features</mat-chip>
      }
      @if (layerContract()) {
      <app-type-chip type="count" [label]="layerTypeLabel()" />
      @if (layerEntity(); as entity) {
      <app-type-chip type="count" [label]="entity" class="ms-1" />
      }
      }
    </div>
    }

    <app-block-debug-meta [kind]="kind()" [data]="data()" />

    @if (capabilities().length > 0) {
    <div class="ai-card__footer px-2 py-1 d-flex align-items-center">
      <app-content-action-bar [capabilities]="capabilities()" [debugMode]="debugMode.isDebugMode()" (actionTriggered)="onAction($event)" />
    </div>
    }
  </mat-card>
} @else {
  <!-- No ref, no value (or an unrecognized kind): generic fallback card -->
  <mat-card appearance="outlined" class="ai-card">
    <app-card-header [displayName]="data().label">
      <app-type-chip type="binary" />
    </app-card-header>

    <app-generic-content-card [label]="data().label" [metadata]="data().metadata" [ref]="null" />

    @if (layerContract()) {
    <div class="px-3 pb-2 d-flex flex-wrap gap-1">
      <app-type-chip type="count" [label]="layerTypeLabel()" />
      @if (layerEntity(); as entity) {
      <app-type-chip type="count" [label]="entity" class="ms-1" />
      }
    </div>
    }
  </mat-card>
}
